import style from "./style.module.scss"
import granda from "../../assets/logos/granda_white.svg"

import fb from "../../assets/fb.svg"
import insta from "../../assets/insta.png"
export default function Logos(){
    return(
        <div className={style.logos}>
                    <div className={style.grandaLogo}>
                        <img src={granda} alt="" />
                    </div>
                    <div className={style.socialmedia}>
                        <img src={fb} alt="" onClick={()=>{window.open("https://www.facebook.com/agencja.ale.granda")}}/>
                        <img src={insta} alt="" onClick={()=>{window.open("https://www.instagram.com/ale_granda_agencja/")}}/>
                    </div>
                </div>
    )
}